import React from "react";

export const AnalyticsBox = ({
    title,
    value,
    unit = "",
    prefix = "",
    roundDigits = 2
}) => {
    return (
        <div className="flex flex-col justify-evenly w-[300px] h-[125px] rounded-2xl bg-white shadow-md p-4">
            <p className="text-sm font-semibold font-nunito text-gray-800">{ title }</p>
            <p className="text-2xl font-bold font-nunito text-black">
                {prefix}{value.toLocaleString(undefined, { minimumFractionDigits: roundDigits, maximumFractionDigits: roundDigits })}{unit}
            </p>
        </div>
    );
};